module.exports = __webpack_public_path__ + "img/sun.26f32e9e.svg";